import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import styled from 'styled-components';

export const EditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

export const StyledAppBar = styled(AppBar)`
  position: initial;
  background: linear-gradient(to right, #8a10d5, #1299e4);
`;

export const StyledToolbar = styled(Toolbar)`
  justify-content: space-between;
`;

export const StyledDrawer = styled.div`
  flex: 1 0 300px;
  min-width: 300px;
  max-width: 70%;
  flex-basis: ${({ width }) => `${width}px`};

  ul, li {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  li {
    padding-inline: 0.75rem;
  }

  li ul li {
    padding-inline-end: 0;
  }

  span {
    font-size: 0.9rem;
    line-height: 1.2rem;
  }

  input, textarea {
    width: 100%;
  }
  
`;

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  height: calc(100% - 64px);
`;